// extracted by mini-css-extract-plugin
export default {"wrapper":"zE","content":"AE","firstSection":"BE","text":"CE","table":"EE","tableText":"FE","row":"GE","column_2":"HE","column_1":"IE","column_3":"JE"};
    if(module.hot) {
      // 1713361651120
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  